import mocker from 'mocker-data-generator';
import { PhraseLocalizationsDocument } from 'src/generated/graphql';
import { MATCH_ANY_PARAMETERS } from 'wildcard-mock-link';
import localization from 'src/api/mocks/types/localization';
import phrase from 'src/api/mocks/types/phrase';
import { MockObject } from '../mocks';
import { extend } from 'lodash';
import variant from '../types/variant';
import xliffLocalization from 'src/api/mocks/types/xliffLocalization';

const phraseWithLocalizations = extend({}, phrase, {
  variant: {
    hasOne: 'fakedVariants',
  },
  'object.format==="xliff",localizations': {
    hasMany: 'fakedXliffLocalizations',
    amount: 5,
  },
  'object.format!=="xliff",localizations': {
    hasMany: 'fakedLocalizations',
    amount: 5,
  },
});

//All data fits in a single page
export const completePhraseLocalizationsMock = (async (): Promise<
  MockObject | MockObject[]
> => {
  const { fakedPhrases } = await mocker()
    .schema('fakedVariants', variant, 1)
    .schema('fakedLocalizations', localization, 8)
    .schema('fakedXliffLocalizations', xliffLocalization, 1)
    .schema('fakedPhrases', phraseWithLocalizations, 1)
    .build();

  const phrase = fakedPhrases[0];

  phrase.localizations = {
    localizationList: phrase.localizations,
    pageInfo: {
      offset: 0,
      count: phrase.localizations?.length || 0,
      totalCount: phrase.localizations?.length || 0,
    },
  };

  return {
    request: {
      query: PhraseLocalizationsDocument,
      variables: MATCH_ANY_PARAMETERS,
    },
    result: {
      data: {
        phrase: phrase,
      },
    },
  };
})();

//Only partial data returned, more pages exist
export const paginatedPhraseLocalizationsMock = (async (): Promise<
  MockObject | MockObject[]
> => {
  const { fakedPhrases } = await mocker()
    .schema('fakedVariants', variant, 1)
    .schema('fakedLocalizations', localization, 8)
    .schema('fakedXliffLocalizations', xliffLocalization, 1)
    .schema('fakedPhrases', phraseWithLocalizations, 1)
    .build();

  const phrase = fakedPhrases[0];

  phrase.localizations = {
    localizationList: phrase.localizations,
    pageInfo: {
      offset: 0,
      count: phrase.localizations?.length || 0,
      // Set totalCount to be 1 more than count to simulate pagination scenario
      totalCount: (phrase.localizations?.length || 0) + 1,
    },
  };

  return {
    request: {
      query: PhraseLocalizationsDocument,
      variables: MATCH_ANY_PARAMETERS,
    },
    result: {
      data: {
        phrase: phrase,
      },
    },
  };
})();
